import { useScrollFadeIn } from '../../../hooks/useScrollFadeIn';

const featureVideos = [
  {
    id: 'armrest',
    youtubeId: 'T2_IJZqKGv4',
    label: '6D Armrest',
    title: '6Dアームレスト',
    desc: '前後・左右・上下・回転・スライド・角度の6軸で自在に調整。どんな姿勢にも完璧にフィットします。',
  },
  {
    id: 'headrest',
    youtubeId: 'GxiRee8RwLk',
    label: '3D Headrest',
    title: '3Dヘッドレスト',
    desc: '上下・前後・角度の3軸調整で、首と頭部を理想のポジションでサポート。長時間の作業も快適に。',
  },
];

export default function Features() {
  const { ref, isVisible } = useScrollFadeIn({ delay: 200 });

  return (
    <section
      ref={ref}
      className={`py-16 md:py-48 px-5 md:px-10 bg-white transition-all duration-1000 ease-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}
    >
      <div className="max-w-5xl mx-auto">
        
        {/* ヘッダー */}
        <div className="text-center mb-12 md:mb-24">
          <p className="text-[10px] tracking-[0.3em] uppercase text-gray-400 font-medium mb-4 md:mb-6">
            Features
          </p>
          <h2 className="text-2xl md:text-6xl font-bold text-gray-900 mb-4 md:mb-6 tracking-tight leading-tight">
            一生モノの椅子を、<br className="md:hidden" />今だけ特別価格で。
          </h2>
          <p className="text-sm md:text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed">
            長時間のデスクワークでもあらゆる姿勢で快適さを保つ、<br className="hidden md:block" />
            仕事も遊びも、境界線を排除して楽しみたい人向けのラグジュアリーワークチェアです。
          </p>
        </div>

        {/* メイン製品動画 */}
        <div className="mb-16 md:mb-32">
          <div className="relative w-full max-w-3xl mx-auto">
            <div className="relative w-full aspect-video rounded-xl md:rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.12)]">
              <iframe
                src="https://www.youtube.com/embed/J1kajQwcP6M?autoplay=1&loop=1&playlist=J1kajQwcP6M&mute=1&controls=1&modestbranding=1&rel=0&playsinline=1"
                title="MeVER Chair 製品動画"
                allow="autoplay; encrypted-media"
                allowFullScreen
                className="absolute inset-0 w-full h-full"
                style={{ border: 'none' }}
              />
            </div>
          </div>
        </div>

        {/* 特徴 - 縦積みスタイル */}
        <div className="space-y-12 md:space-y-24 mb-20 md:mb-40">
          {[
            {
              icon: 'ri-user-heart-line',
              title: '人間工学に基づいた設計',
              desc: '長時間座っても疲れにくい、体圧分散メッシュ設計。腕・腰・背中・首をしっかりサポート。',
            },
            {
              icon: 'ri-settings-3-line',
              title: '16ヶ所の多機能調整機構',
              desc: '6Dアームレスト・3Dヘッドレスト・1D上下バックレスト・2Dランバーサポート・2D座面・2Dフットレストを自由に調整可能。',
            },
            {
              icon: 'ri-shield-check-line',
              title: '5年間の製品保証',
              desc: '通常使用における故障や不具合を無償で修理・交換。安心の長期保証。',
            },
          ].map((feature, i) => (
            <div
              key={i}
              className="text-center max-w-2xl mx-auto"
            >
              <div className="w-14 h-14 md:w-20 md:h-20 flex items-center justify-center mx-auto mb-5 md:mb-8">
                <i className={`${feature.icon} text-4xl md:text-6xl text-gray-800`}></i>
              </div>
              <h3 className="text-lg md:text-3xl font-bold text-gray-900 mb-3 md:mb-4">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-gray-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>

        {/* ─── 機能動画セクション ─── */}
        <div className="mb-20 md:mb-40">
          {/* セクションヘッダー */}
          <div className="text-center mb-10 md:mb-16">
            <p className="text-[10px] tracking-[0.4em] uppercase text-gray-400 font-medium mb-3 md:mb-4">
              In Action
            </p>
            <h3 className="text-xl md:text-4xl font-bold text-gray-900 leading-tight">
              動いて、はじめてわかる。
            </h3>
            <p className="text-sm text-gray-400 mt-3 md:mt-4 max-w-md mx-auto leading-relaxed">
              細部まで妥協しない調整機構を、実際の動きでご確認ください。
            </p>
          </div>

          {/* 動画カード 2列 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {featureVideos.map((video) => (
              <div key={video.id} className="group">
                {/* 動画プレーヤー */}
                <div className="relative w-full aspect-video rounded-xl md:rounded-2xl overflow-hidden bg-gray-50 shadow-[0_8px_32px_rgba(0,0,0,0.08)] transition-shadow duration-500 group-hover:shadow-[0_16px_48px_rgba(0,0,0,0.14)]">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.youtubeId}?controls=1&modestbranding=1&rel=0&playsinline=1`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="absolute inset-0 w-full h-full"
                    style={{ border: 'none' }}
                  />
                </div>

                {/* テキスト情報 */}
                <div className="mt-5 md:mt-6 px-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[9px] tracking-[0.35em] uppercase text-gray-400 font-semibold">
                      {video.label}
                    </span>
                    <span className="flex-1 h-px bg-gray-100"></span>
                  </div>
                  <h4 className="text-base md:text-xl font-bold text-gray-900 mb-2">
                    {video.title}
                  </h4>
                  <p className="text-sm text-gray-500 leading-relaxed">
                    {video.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* MeVERのビジョン（ダークセクション） */}
        <div className="relative overflow-hidden rounded-2xl md:rounded-3xl bg-[#080808] py-16 md:py-32 px-6 md:px-16 mb-20 md:mb-40">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-white/5 rounded-full blur-[120px] pointer-events-none"></div>
          
          <div className="relative z-10 max-w-2xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-6 md:mb-10">
              <div className="w-1.5 h-1.5 rounded-full bg-white/60 animate-pulse"></div>
              <span className="text-xs font-semibold text-white/50 tracking-widest uppercase">Our Vision</span>
            </div>
            <h3 className="text-2xl md:text-5xl font-bold text-white mb-5 md:mb-8 leading-tight">
              はたらく、あそぶ、<br />その境界を自由に。
            </h3>
            <p className="text-sm md:text-lg text-white/50 leading-relaxed">
              MeVER（ミーバー）は、東京から世界へ発信するクリエイティブチームです。日本独自の細やかな感性と、グローバルな視点を持つ東京都福生市のグローバルメンバーが集結し、「ONとOFFの質を最大化する空間設計」を追求しています。<br /><br />
              ビットムーブスジャパン株式会社が運営する東京発のブランドとして、私たちは単なる家具の提供に留まりません。クリエイターやビジネスマンのパフォーマンスを支え、日常のあらゆるシーンにインスピレーションをもたらすプロダクト＆サービス。それがMeVERの約束です。
            </p>
          </div>
        </div>

        {/* ブランドの約束 */}
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-20">
            <p className="text-[10px] tracking-[0.3em] uppercase text-gray-400 font-medium mb-4 md:mb-6">
              Our Promise
            </p>
            <h3 className="text-xl md:text-4xl font-bold text-gray-900 mb-4">
              MeVERの約束
            </h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-12">
            {[
              {
                icon: 'ri-shield-check-line',
                title: '30日間返品保証',
                desc: '座り心地が合わなくても安心です。※返品状態によって金額比率が変動します。詳しくはFAQをご確認ください。',
              },
              {
                icon: 'ri-customer-service-2-line',
                title: '充実のサポート体制',
                desc: '当社は純粋な日本の会社です。責任を持って丁寧にサポートいたします。',
              },
              {
                icon: 'ri-recycle-line',
                title: '環境への配慮',
                desc: '長く使える製品設計で、持続可能な社会に貢献します。一生使える椅子を目指しています。',
              },
              {
                icon: 'ri-star-line',
                title: '品質へのこだわり',
                desc: '確かな品質をリーズナブルにお届けします。',
              },
            ].map((promise, i) => (
              <div
                key={i}
                className="text-center"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center mx-auto mb-4 md:mb-5">
                  <i className={`${promise.icon} text-3xl md:text-4xl text-gray-800`}></i>
                </div>
                <h4 className="text-base md:text-xl font-bold text-gray-900 mb-2 md:mb-3">
                  {promise.title}
                </h4>
                <p className="text-sm md:text-base text-gray-500 leading-relaxed">
                  {promise.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
